/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * MessJob model representing a measurement job
 */
export type MessJobEntityCreate = {
    /**
     * MessJob name
     */
    name: string;
    /**
     * MessJob type (default|project)
     */
    type: MessJobEntityCreate.type;
    /**
     * Associated MessProject ID
     */
    messproject_id: string;
    status?: string;
    /**
     * Creation mode of the MessJob (simple|incremental|rollating)
     */
    creation_mode?: MessJobEntityCreate.creation_mode;
};
export namespace MessJobEntityCreate {
    /**
     * MessJob type (default|project)
     */
    export enum type {
        DEFAULT = 'default',
        PROJECT = 'project',
    }
    /**
     * Creation mode of the MessJob (simple|incremental|rollating)
     */
    export enum creation_mode {
        SIMPLE = 'simple',
        INCREMENTAL = 'incremental',
        ROLLATING = 'rollating',
    }
}

